import { Component, OnInit, TemplateRef } from '@angular/core';
import { ConnectionService } from '../../connection.service';
import { ToastrService } from 'ngx-toastr';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

@Component({
	selector: 'app-record-token',
	templateUrl: './record-token.component.html',
	styleUrls: ['./record-token.component.css']
})
export class RecordTokenComponent implements OnInit {
	tokenObj: any = {
	}
	modalRef?: BsModalRef;

	rect: number = 1; inum = '0';
	token: string;
	getAddToken: any;
	filesToUpload: Array<File> = []; imgsize = false; imgvalid = false; showimg = false; getDecimals: any; decimals: any;
	addHis: any; condetails: any = {}; tokenLoader = false; userAddress: any;
	isConfirmed: Boolean = false
	tokenType: any;
	imageToShow: string | ArrayBuffer;
	imageFile: any;
	token_logo: any;
	Token_logoDetails: any
	tokenStandard: any;
	balance: any;
	constructor(private conn: ConnectionService, private alert: ToastrService, private route: Router, private spinner: NgxSpinnerService, private modalService: BsModalService) {
		this.conn.coinBalance.subscribe((res: any) => {
			this.balance = res
		})
	}

	ngOnInit() {
		this.userAddress = localStorage.getItem('Address')
		this.token = localStorage.getItem('Sastana_Token')
		this.getRecordToken();
	}

	getRecordToken() {
		this.conn.postUrl('token/recordToken', {}).subscribe((res: any) => {
			this.getAddToken = res.data
		})
	}

	getTokentype(type: any) {
		this.tokenType = type
		this.confirmType(this.tokenType)
	}

	confirmType(type) {
		this.isConfirmed = true
	}
	submitFunc(sastform: NgForm) {
		var data = sastform.value;
		if (this.imgvalid) {
			this.alert.error("Invalid Image");
			return;
		}
		if (sastform.valid) {
			let postData = {
				tokenType: this.tokenType,
				contractAddress: data.conaddress,
				contractName: data.conname,
				contractDate: data.condate,
				contractCreator: data.conowner || this.userAddress,
				token_name: data.tokenname,
				token_symbol: data.abbre,
				annoucements: data.intro,
				supply: data.supply,
				decimal: data.decimal,
				coin_website: data.url,
				email: data.email,
				token_logo: this.Token_logoDetails,
				whitePaperLink: data.whitep,
				twitterLink: data.twitter,
				facebookLink: data.facebook,
				telegramLink: data.telegram,
				linkedinLink: data.linkedin,
				githubLink: data.githup
			}
			this.spinner.show()
			this.conn.filePostRequest('token/addToken', postData, this.token).subscribe((res: any) => {
				if (res.status == true) {
					this.spinner.hide()
					this.alert.success('Token added successfully');
					sastform.reset()
					window.location.reload()
				} else {
					this.spinner.hide()
					this.alert.error(res.msg);
				}
			});
		}
		else {
			this.alert.error('Fill all the required fields');
		}

	}


	onFileSelected(event: any) {
		if (!event.target.files[0] || event.target.files.length == 0) {
			return;
		}
		var mimeType = event.target.files[0].type;
		const file = event.target.files[0];
		let file_size = file.size / 1024 / 1024;

		if (mimeType.match(/image\/*/) == null) {
			this.alert.error('error', "File Not Supported")
			return;
		}
		if (file_size >= 1) {
			this.alert.error('error', "Upload image should be less than or equal to 1MB");
			return;
		}
		var reader = new FileReader();
		reader.readAsDataURL(event.target.files[0]);
		reader.onload = (_event) => {
			this.imageToShow = reader.result;
			this.imageFile = event.target.files[0];
			this.token_logo = this.imageFile
			this.imageUpload2()
		}
	}

	imageUpload2() {
		let formData = new FormData();
		formData.append('file', this.token_logo)
		this.conn.filePostRequest('cmsapi/uploadprocess', formData, this.token).subscribe((res: any) => {
			this.Token_logoDetails = res.data
		})
	}

	getContractDetails(contract?: any) {
		this.conn.postUrl('user_contract/getContractInfo', { address: contract }).subscribe((res: any) => {
			if (res.success == true) {
				this.tokenObj.conname = res.data.name
				this.tokenObj.conowner = res.data.ownerAddress
				this.tokenObj.condate = res.data.created_at
			}
		})
	}

	openModal(template: TemplateRef<any>) {
		setTimeout(() => {
			if (this.balance < 1024) {
				this.modalRef = this.modalService.show(template);
			}
			else {
				this.getTokentype('ABC10')
			}
		}, 2000)
	}

	validateTokentype(contract?: any) {
		this.conn.postUrl('contract/getTokentype', { address: this.userAddress, contractAddress: contract }).subscribe((res: any) => {
			if (res.status == true) {
				this.tokenStandard = res.data
			}
		})
	}
}
